module.exports = __webpack_public_path__ + "images/application/i-monthly-plan-8a4fc66b.svg";